import dayjs from 'dayjs'
import uuid from 'react-uuid'
//import { message } from 'antd'

const info = text => {

  // TODO: SCAN
  //message.info(text)
  alert (text)
}

let isIOSDenyCamera = false

export function isIOS() {
  return (
    ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(
      navigator.platform
    ) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

export function isAndroid(){
  let ua = navigator.userAgent.toLowerCase();
  let android = ua.indexOf("android") > -1 && ua.indexOf("mobile") > -1;
  let chrome = window.chrome;
  if(android && chrome) return true;
  return false;
}

export function isMobile(){
  let mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
  try{
    if(navigator.userAgent.includes('SamsungBrowser') && DeviceMotionEvent !== undefined)
      return true;
    if(!mobile && navigator.userAgent.includes('Macintosh') &&
       DeviceMotionEvent !== undefined &&
       !navigator.userAgent.includes('Chrome') &&
       !navigator.userAgent.includes('Firefox')) return true;

    // Check for Edge tablets and other tablets by screen dimensions
    // Tablets typically have screens between 600-1400px width in portrait or landscape
    if(!mobile) {
      const width = window.innerWidth || window.screen.width;
      const height = window.innerHeight || window.screen.height;
      const minDimension = Math.min(width, height);
      const maxDimension = Math.max(width, height);

      // Detect tablets by screen size (portrait: 600-1024px width, landscape: height < width)
      const isTabletSize = (minDimension >= 600 && minDimension <= 1024) ||
                          (maxDimension >= 1024 && maxDimension <= 1400 && minDimension >= 600);

      // Check if device has touch support
      const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

      // Detect Edge browser on Windows tablets
      const isEdge = /Edg/i.test(navigator.userAgent);

      if(isTabletSize && hasTouch && (isEdge || DeviceMotionEvent !== undefined)) {
        return true;
      }
    }

    return mobile;
  }catch(e){
    return false;
  }
} 

export const deviceId = uuid();
let myScanId = null;
export function getScanId(isNew){
  if(myScanId === null || isNew){
    myScanId = dayjs().format('DD_MM_YYYY_HH_mm_ss');
  }
  return myScanId;
}

export const allowOrDeniedCameraAccess = async func => {
  if (isIOS && isIOSDenyCamera) {
    info('Camera access was denied by user.')
    return
  }
  const stream = await navigator.mediaDevices
    .getUserMedia({ audio: false, video: { width: { min: 640 }, height: { min: 480 } } })
    .catch(err => {
      info('Camera access was denied by user.')
      console.log(err.name + ': ' + err.message)
      if (isIOS) isIOSDenyCamera = true
    })
  if (stream) {
    func()
  }
}
